import React from 'react';
import {
    PricingProvider,
    PricingConfiguration,
    PricingContext,
    BuyableFeePolicy,
} from '@fiverr-private/price_upfront_sdk';
import { PricingProviderContent } from './content/PricingProviderContent';

interface PricingProviderWithToastProps {
    priceUpfrontConfiguration?: PricingConfiguration;
    priceUpfrontContext?: PricingContext;
    isPriceUpfrontEnabled: boolean;
    priceUpfrontBuyableFeePolicy?: BuyableFeePolicy;
}

export const PricingProviderWithToast: React.FC<PricingProviderWithToastProps> = ({
    priceUpfrontConfiguration,
    priceUpfrontContext,
    isPriceUpfrontEnabled,
    priceUpfrontBuyableFeePolicy,
    children,
}) => (
    <PricingProvider
        priceUpfrontConfiguration={priceUpfrontConfiguration}
        priceUpfrontContext={priceUpfrontContext}
        isPriceUpfrontEnabled={isPriceUpfrontEnabled}
        priceUpfrontBuyableFeePolicy={priceUpfrontBuyableFeePolicy}
    >
        <PricingProviderContent>{children}</PricingProviderContent>
    </PricingProvider>
);
